export default "assets/images/icons/slider-arrow-d501cacd.svg";